import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { createZitadelAuth, ZitadelAuth } from '@zitadel/react';

const LoginCallback: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const zitadel: ZitadelAuth = createZitadelAuth({
      authority: process.env.REACT_APP_ZITADEL_AUTHORITY!,
      client_id: process.env.REACT_APP_ZITADEL_CLIENT_ID!,
      redirect_uri: `${window.location.origin}/login/callback`,
      response_type: 'code',
      scope: 'openid profile email',
    });

    zitadel.userManager
      .signinRedirectCallback()
      .then(() => {
        navigate('/');
      })
      .catch((err: Error) => {
        console.error('Login callback error:', err);
        // You could add UI feedback or redirect here if desired
      });
  }, [navigate]);

  return <div>Processing login...</div>;
};

export default LoginCallback;
